<script>
export default {
  created() {
  },
  props: {
      codeEvent: {
         type: Function
      },
      searchEvent: {
          type: Function
      },
      codeDetail: {
          type: Object
      },
      selectOption: {
          type: Object
      },
      dialogOption: {
          type: Object
      }
  },
  data() {
      return {
          codeQuery: {
              id: '',
              title: '',
              bidTypeId: '',
          },
          authQuery: {
              id: '',
              authStatus: ''
          }
      }
  },
  methods: {
      modelStatus(val) {
          this.dialogOption.show = val;
          this.initQuery();
      },
      initQuery() {
          switch(+this.dialogOption.type) {
              case 0:
                  this.$clearObject(this.codeQuery);
                  break;
              case 1:
                  this.$setObject(this.codeQuery,this.codeDetail);
                  break;
              case 2:
                  this.$setObject(this.authQuery,this.codeDetail);
                  break;
          }
      },
      async submit() {
        const {type} = this.dialogOption;
        const {code} = await this.codeEvent(type === 1 ? this.codeQuery : this.authQuery);
        if (Object.is(code, 200)) {
            this.searchEvent();
            this.$message.success(`${this.dialogOption.title}成功`);
        }
        this.dialogOption.show = false;
        this.$clearObject(this.codeQuery);
      }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
      codeDetail(val) {
          this.$setObject(this.codeQuery, val);
      }
  }
}
</script>
<template>
<div class="edit">
  <el-dialog
    :title="dialogOption.title"
    :width="dialogOption.width"
    :visible.sync="dialogOption.show"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <el-form :model="codeQuery" ref="information">

      <el-form-item label="跟进状态" label-width="80px">
          <el-select v-model="authQuery.authStatus" class="common-width"
			   placeholder="跟进状态"
			>
				<el-option
					v-for="item in selectOption.authStatus"
					:key="item.key"
					:label="item.typeName"
					:value="item.key"
				>
				</el-option>
			</el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
          <el-button @click="dialogOption.show = false" size="small">取消</el-button>
          <el-button type="success"
            @click="submit" size="small">提交</el-button>
    </div>
</el-dialog>
</div>
</template>
<style scoped lang="stylus">


</style>
